import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useMutation } from 'react-query';
import { ConfirmNewsletter } from 'services/newsletter';

import LinkButton from '@core/components/linkbutton/LinkButton';
import Spinner from '@core/components/spinner/Spinner';

import { NextSeo } from 'next-seo';
import { generateSeoProps } from 'router/seoprops/generateSeoProps';

import FailedVerification from 'assets/images/empty-search.svg';
import SuccessVerification from 'assets/images/email-verify.svg';

import classes from './index.module.scss';

const NewsletterConfirmPage = () => {
	const router = useRouter();
	const { mutate, isError, isLoading, data } = useMutation(ConfirmNewsletter);

	const seoProps = generateSeoProps({
		title: 'Pharmuni | NewsLetter Confirm',
		canonical: 'newsletter-confirm'
	});

	useEffect(() => {
		if (router.isReady) {
			mutate({ token: router?.query?.token });
		}
	}, [router.isReady, router?.query?.token]);

	return (
		<>
			<NextSeo {...seoProps} />
			{isLoading ? (
				<div className={classes['loading']}>
					<Spinner />
				</div>
			) : (
				<section className={`${classes['newsletter-container']} container my-3`}>
					{!isError && data ? (
						<>
							<SuccessVerification />
							<h1>Welcome to the Pharmuni newsletter</h1>
							<p>{data?.data.message}</p>
							<LinkButton kind="primary-color" className={classes['link-buttton']} to="/" replace>
								Go to Home
							</LinkButton>
						</>
					) : (
						<>
							<FailedVerification />
							<h1>Oh oh!</h1>
							<p>Your verification link is incorrect or has expired.</p>
						</>
					)}
				</section>
			)}
		</>
	);
};

export default NewsletterConfirmPage;
